import { useState } from "react";
import { useEffect } from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";

import Grid from "@mui/material/Grid";

import * as PartnerSessionActions from "../../state/redux/partnerSession";
import * as UserSessionStorage from "../../utils/userSessionStorage";
import Portal from "../ui/portal";
import PortalAppBar from "../ui/portalAppBar";
import PortalGridContent from "../ui/portalGridContent";
import PartnerPatients from "../widgets/partnerPatients";
import PartnerTodo from "../widgets/partnerTodo";

const PartnerPortal = props => {
  const { partnerODM, userODM, partnerPatients, loadPartnerODMRequest } = props;

  const [partnerIsUser, setPartnerIsUser] = useState(true);

  useEffect(() => {
    if (partnerODM == null && userODM != null) {
      if (userODM.omniData.hasOwnProperty("partnerData")) {
        loadPartnerODMRequest(userODM._id);
      } else {
        const lastId = UserSessionStorage.tryRestoreLastPartnerId();
        if (lastId != null) {
          loadPartnerODMRequest(lastId);
        }
      }
    }
    if (partnerODM) {
      UserSessionStorage.storeLastPartnerId(partnerODM._id);
    }
    if (partnerODM && userODM && partnerODM._id !== userODM._id) {
      setPartnerIsUser(false);
    }
  }, [partnerODM, userODM, loadPartnerODMRequest]);

  return (
    <Portal>
      <PortalAppBar hideMenu="true" />
      {partnerODM && (
        <PortalGridContent>
          {partnerIsUser && (
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <PartnerTodo />
            </Grid>
          )}
          {partnerPatients && partnerPatients.length > 0 && (
            <Grid item xs={12} sm={12} md={6} lg={4}>
              <PartnerPatients />
            </Grid>
          )}
          <Grid item xs={12}></Grid>
        </PortalGridContent>
      )}
    </Portal>
  );
};

const mapStateToProps = state => ({
  partnerODM: state.partnerSession.partnerODM,
  partnerAssessments: state.partnerSession.partnerAssessments,
  partnerPatients: state.partnerSession.partnerPatients,
  userODM: state.userSession.userODM,
});

const mapDispatchToProps = {
  loadPartnerODMRequest: PartnerSessionActions.loadPartnerODMRequest,
};

export default connect(mapStateToProps, mapDispatchToProps)(withRouter(PartnerPortal));
